export enum OtherIntegrations {
  WINDOWS = "mondoo/windows",
  LINUX = "mondoo/linux",
  MACOS = "mondoo/macos",
  CISCO = "mondoo/cisco",
  VMWARE = "mondoo/vmware",
  PACKER = "hashicorp/packer",
  TERRAFORM = "hashicorp/terraform",
  CREDENTIALS = "mondoo/credentials",
  WORKSTATION_MONDOO = "workstation/mondoo",
  CHATOPS_MSTEAMS = "chatops/msteams",
  MSTEAMS = "MSTEAMS",
  CHATOPS_SLACK = "chatops/slack",
  SLACK = "SLACK",
  CHATOPS_TELEGRAM = "chatops/telegram",
  TELEGRAM = "TELEGRAM",
  CHATOPS_WEBHOOK = "chatops/httppost",
  WEBHOOK = "HTTPPOST",
  PANOS = "mondoo/panos",
  FORTIOS = "mondoo/fortios",
  JUNOS = "mondoo/junos",
}

type Flag = {
  id: string;
  title: string;
};

export type IntegrationAddHeaderData = {
  title: string;
  tagline: string;
  flags: Flag[];
  docsLink: string;
};
